import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Store } from '@ngrx/store';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { Language } from 'app/shared/model/enums';
import { Subscription } from 'rxjs';
import { Question } from '../declarations';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit {
  activeState: boolean[] = [true, false, false];
  subscriptions = new Subscription();

  currentQuestions: Question[];

  heStrings: Question[] = [
    {
      'question': "איך הלקוח מקבל ממני את הרולטה?",
      'answer': "יש המון דרכים לעשות שימוש ברולטה, שליחה לוואטסאפ, מייל, פוספ, סטטוס, להטמיע באתר האינטרנט של העסק, ושליחה למאגרים שונים"
    },
    {
      'question': "למה זה עדיף מפרסום רגיל?",
      'answer': "אנשים אוהבים מתנות, אנשים מרגישים רגש חיובי כלפי מי שנותן להם מתנה, אנשים אוהבים לשחק ולזכות במתנת רולטה, והכי חשוב, בשונה מפרסום רגיל, הלקוחות משאירים לך פרטי התקשרות עתידיים"
    },
    {
      'question': "האם זה לא הפסד כספי בגלל חלוקת המתנות?",
      'answer': "ממש לא, זה חוסך לך בהוצאות הפרסום, וזה מביא לך הרבה יותר לקוחות לעסק, אם הלקוח לא סגר עסקה - זה לא עלה לך כלום... מתנה קטנה יכולה להביא לך עסקה גדולה"
    },
    {
      'question': "איך אני בוחר את המתנות ללקוחות?",
      'answer': "בדיוק בשביל זה הכנו עבורך הדרכה מיוחדת, איך למנף את העסק באמצעות מתנות (לינק...)"
    }
  ]


  enStrings: Question[] = [
    {
      'question': " How does Spin to Win improve profitability?",
      'answer': "By increasing customer engagement and encouraging repeat purchases, Spin to Win drives sustained growth in your revenue."
    },
    {
      'question': "Can I customize the spin wheel for my business?",
      'answer': "Absolutely! From colors to rewards, Spin to Win is fully customizable to fit your unique brand identity."
    },
    {
      'question': "Can I add Spin to Win in my own website?",
      'answer': "Absolutely! Use Spin to Win in your own website by simply adding our Iframe code."
    },
    {
      'question': " Is the platform easy to use for someone who isn't tech-savvy?",
      'answer': "Yes! Spin to Win is designed with simplicity in mind, making it accessible to everyone – even those with little to no tech experience."
    },
    {
      'question': "How quickly can I see results?",
      'answer': "Many of our clients report noticeable engagement boosts within the first two weeks of implementation."
    }
 
  ]


  constructor(store: Store<AppState>) {
    this.subscriptions.add(store.select(selectLanguageInCommonState).subscribe(language => {
      this.loadData(language);
    }));
  }

  ngOnInit(): void {
  }

  loadData(language: Language) {
    //Using Map
    let map = new Map<Language, Question[]>();
    map.set(Language.en, this.enStrings);
    map.set(Language.bg, this.enStrings);
    map.set(Language.he, this.heStrings);

    this.currentQuestions = map.get(language)
  }

  toggle(index: number) {
    this.activeState[index] = !this.activeState[index];
  }
}


